/**
 * Page cameras carry Mapbox zooms. Mapbox tiles are 512 px, so one Mapbox
 * level shows the same scale as the next Google level up.
 */
export const toGoogleZoom = (zoom: number) => zoom + 1;

/** The page's Mapbox zoom for a Google zoom. */
export const fromGoogleZoom = (zoom: number) => zoom - 1;
